import { render, staticRenderFns } from "./HistoryUserDentist.vue?vue&type=template&id=3d12807d&scoped=true&"
import script from "./HistoryUserDentist.vue?vue&type=script&lang=js&"
export * from "./HistoryUserDentist.vue?vue&type=script&lang=js&"
import style0 from "./HistoryUserDentist.vue?vue&type=style&index=0&id=3d12807d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d12807d",
  null
  
)

export default component.exports